import { render, staticRenderFns } from "./CancellationPolicies.vue?vue&type=template&id=fb2e5728&scoped=true"
import script from "./CancellationPolicies.vue?vue&type=script&lang=js"
export * from "./CancellationPolicies.vue?vue&type=script&lang=js"
import style0 from "./CancellationPolicies.vue?vue&type=style&index=0&id=fb2e5728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e5728",
  null
  
)

export default component.exports